import { Center, Text } from "@chakra-ui/react";

const Footer = () => {
  return (
    <Center h={20}>
      <Text color={"white"}>Copyright © 2022, All Rights Reserved</Text>
    </Center>
  );
};

export default Footer;
